import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductosRoutingModule} from './productos-routing.module';
import {LayoutModule} from '../../layout/layout.module';
import {ListaProductosComponent} from './lista-productos/lista-productos.component';
import {MatDividerModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule} from '@angular/material';
import {NgxPaginationModule} from 'ngx-pagination';
import {GeneralesModule} from '../../shared/generales/generales.module';
import {FormsModule} from '@angular/forms';
import {DetalleProductoComponent} from './detalle-producto/detalle-producto.component';
import {ProductDetailSidebarComponent} from './product-detail-sidebar/product-detail-sidebar.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {NgxImgZoomModule} from 'ngx-img-zoom';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  declarations: [
    ListaProductosComponent,
    DetalleProductoComponent,
    ProductDetailSidebarComponent,
  ],
  imports: [
    CommonModule,
    ProductosRoutingModule,
    LayoutModule,
    MatFormFieldModule,
    NgxPaginationModule,
    GeneralesModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    MatDividerModule,
    SlickCarouselModule,
    NgxImgZoomModule,
    MatButtonModule,
    MatListModule,
  ],
  exports: []
})
export class ProductosModule {
}
